import styled from '@emotion/styled';
import { spacing } from '../../../../../themes';

export const WizardButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing.small};
`;
